import { useAudioVideo } from '@providers/AudioVideoProvider';
import {
  useContentShareControls,
  useContentShareState,
} from '@providers/ContentShareProvider';
import { type FC } from 'react';
import { Container, IconWrapper } from './style';
import Icon from '/icon/screenpairing.svg';

const ContentShareToggle: FC = () => {
  const { isLocalUserSharing } = useContentShareState();
  const { togglePauseContentShare } = useContentShareControls();
  const audioVideo = useAudioVideo();

  const onClick = () => {
    audioVideo?.startContentShareFromScreenCapture();
  };

  return (
    <Container onClick={onClick} isActive={isLocalUserSharing}>
      <IconWrapper>
        <img src={Icon} />
      </IconWrapper>
      <span>화면 공유</span>
    </Container>
  );
};

export default ContentShareToggle;
